<template>
  <div>
  <section class="no-bottom-border border-top">
    <div class="left">
      <h2 v-translate>Uvítací obrazovka</h2>
    </div>
  <div class="right">
    <div class="field_left">
      <checkbox-input
          id="welcome_screen_settings_enabled"
          v-model="entity.welcome_screen_settings.enabled"
          ref="welcomescreensettingsenabledref"
          :disabled="!isEditable"
      >
        <translate class="translate">Vlastní uvítací obrazovka</translate>
      </checkbox-input>
    </div>
    <div class="field checkboxes_inline">
      <p class="field">
        <radio-input
            id="any_key"
            name="any_key"
            p-class="field"
            v-model="keysType"
            :val="keysType"
            :disabled="!isWelcomeScreenEditable"
        >
          <translate class="translate">Potvrdit uvítací obrazovku libovolným tlačítkem dálkového ovládání</translate>
        </radio-input>
      </p>
      <p class="field">
        <radio-input
            id="selected_key"
            name="selected_key"
            p-class="field"
            v-model="keysType"
            :val="keysType"
            :disabled="!isWelcomeScreenEditable"
        >
          <translate class="translate">Potvrdit uvítací obrazovku pouze vybranými tlačítky dálkového ovládání</translate>
        </radio-input>
      </p>
    </div>
  </div>
    <checkbox-list
        key="formatTags"
        name="format"
        :options="keysOptions"
        v-model="entity.welcome_screen_settings.confirm_keys"
        :disabled="!isWelcomeScreenEditable || entity.welcome_screen_settings.confirm_by_any_key">
    </checkbox-list>
  </section>
    <TranslationFormPart
        id="welcomescreentranslation"
        :form-settings="translationFormSettings"
        :disabled="!isWelcomeScreenEditable"
        v-model="entity.welcome_screen_settings.translations"
    />
  </div>
</template>

<script>

import CheckboxList from "../../../common/CheckboxList.vue";
import TranslationLanguageSelector from "../../../common/TranslationLanguageSelector.vue";
import TranslationFormPart from "../../../common/TranslationFormPart.vue";

export default {
  name: "WelcomeScreenSettings",
  components: {TranslationFormPart, TranslationLanguageSelector, CheckboxList},
  props: {
    entity: Object,
    isEditable: Boolean,
    keysOptions: Array,
  },
  data(){
    return {
      translationFormSettings: [
        {
          name: "version",
          type: "text",
          title: this.$gettext("Verze uvítací obrazovky"),
          helpText: this.$gettext('Pro zobrazení musí verze být vyšší než je aktuální verze ve storage zařízení'),
          required: true,
        },
        {
          name: "title",
          type: "text",
          title: this.$gettext("Titulek uvítací obrazovky"),
          required: false,
        },
        {
          name: "body_html",
          type: "textarea",
          title: this.$gettext("HTML uvítací obrazovky"),
          required: false,
        }
      ]
    }
  },
  computed: {
    isWelcomeScreenEditable(){
      return this.isEditable && this.entity.welcome_screen_settings.enabled;
    },
    keysType: {
      get(){
        return this.entity.welcome_screen_settings.confirm_by_any_key ? 'any_key': 'selected_key';
      },
      set(value){
        this.entity.welcome_screen_settings.confirm_by_any_key = value === 'any_key';
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/initialProcessSetup/forms/WelcomeScreenSettings.vue